/**
 * GraphControls Component
 * Zoom controls and color-by toggle for the ecosystem graph
 * (Filters are now handled by the parent Directory page)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, ButtonGroup } from 'react-bootstrap';

export default function GraphControls({
    filters,
    onFilterChange,
    onZoomIn,
    onZoomOut,
    onResetZoom,
}) {
    return (
        <div className="graph-controls d-flex align-items-center justify-content-center gap-3">
            {/* Color By Toggle */}
            <Form.Group className="d-flex align-items-center gap-2 mb-0">
                <Form.Label className="small fw-medium mb-0 text-nowrap">
                    Color by
                </Form.Label>
                <Form.Select
                    size="sm"
                    className="select-auto-width"
                    value={filters.colorBy}
                    onChange={(e) => onFilterChange('colorBy', e.target.value)}
                >
                    <option value="sector">Sector</option>
                    <option value="region">Region</option>
                </Form.Select>
            </Form.Group>

            {/* Zoom Controls */}
            <ButtonGroup size="sm">
                <Button
                    variant="outline-secondary"
                    onClick={onZoomIn}
                    title="Zoom In"
                    aria-label="Zoom In"
                >
                    +
                </Button>
                <Button
                    variant="outline-secondary"
                    onClick={onZoomOut}
                    title="Zoom Out"
                    aria-label="Zoom Out"
                >
                    -
                </Button>
                <Button
                    variant="outline-secondary"
                    onClick={onResetZoom}
                    title="Fit to View"
                    aria-label="Fit to View"
                >
                    Fit
                </Button>
            </ButtonGroup>
        </div>
    );
}

GraphControls.propTypes = {
    filters: PropTypes.shape({
        colorBy: PropTypes.string,
    }).isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onZoomIn: PropTypes.func.isRequired,
    onZoomOut: PropTypes.func.isRequired,
    onResetZoom: PropTypes.func.isRequired,
};
